import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

export const CardContainer = styled.div.attrs({
  className: 'card-container',
})`
  position: relative;
  width: var(--card-width, 288px);

  > * {
    height: 100%;
  }
`;

export const LeftAlignedCarouselContainer = styled(Stack)`
  .placeholder-card {
    opacity: 0;
    pointer-events: none;
    z-index: -1;
  }

  ${mediaQuery(
    'sm',
    css`
      /* Make sure if fits smaller screens */
      ${CardContainer}, .placeholder-card {
        width: 288px;
      }
    `
  )}
`;

export const CarouselContainer = styled(Stack)`
  width: 100vw;
  left: 0;
  top: 0;
  padding-left: var(--carousel-padding-left, 0px);

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const FullWidthCarouselContainer = styled(Stack)`
  top: 0;
  left: var(--carousel-left-position, 0px);
  width: 100vw;
  height: 100%;
`;

export const CarouselRail = styled(Stack)`
  width: max-content;
`;
